import {
  ApiBlobGetRequest,
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Kas Keluar',
    title_form: 'Form Kas Keluar',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Kas Keluar',
        href: '/adm/fin/kas-bank/kas-keluar',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_kas_keluar',
    sortDesc: true,
    fields: [
      {
        key: 'code_kas',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'tgl_bayar',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'recipient',
        label: 'Diterima Oleh',
        sortable: true,
      },
      {
        key: 'memo',
        label: 'Notes',
        sortable: true,
      },
      {
        key: 'total_kas',
        label: 'Total',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      date_journal: '',
      notes: '',
      id_supplier: '',
      supplier_name: '',
      acc_cash: '',
      acc_cash_code: '',
      acc_cash_name: '',
      items: [
        {
          id_account: '',
          id_department: '',
          description: '',
          debet: '',
          kredit: '',
        },
      ],
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeKasKeluar(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournalKasKeluar({ commit }, paylad = null) {
    commit('changeKasKeluar', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/kas-keluar/${paylad.id}/journal`);
    commit('changeKasKeluar', {
      loading: false,
      journal: result.error ? [] : result.data.object,
    });

    return !result.error ? true : false;
  },

  async getKasKeluar({ commit, state }, payload = {}) {
    commit('changeKasKeluar', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/kas-keluar`, params);
      commit('changeKasMasuk', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_kas_keluar.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest('fin/kas-keluar', params);
      commit('changeKasKeluar', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailKasKeluar({ commit, state }, payload = null) {
    commit('changeKasKeluar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/kas-keluar/${payload.id}`);
    commit('changeKasKeluar', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKasKeluar', {
        form: {
          ...data.form,
          ...result.data.object,
          tgl_bayar: result.data.object.tgl_bayar
            ? moment(result.data.object.tgl_bayar).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async getLastId({ commit, state }) {
    commit('changeKasKeluar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/kas-keluar/get_last_id`);
    commit('changeKasKeluar', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKasKeluar', {
        form: {
          ...data.form,
          code_journal: result.data.object,
        },
      });

      return true;
    }

    return false;
  },

  async createKasKeluar({ commit, state, dispatch }) {
    commit('changeKasKeluar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/kas-keluar', data.form);

    commit('changeKasKeluar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateKasKeluar({ commit, state, dispatch }, payload = null) {
    commit('changeKasKeluar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`fin/kas-keluar/${payload.id}`, data.form);

    commit('changeKasKeluar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteKasKeluar({ commit, dispatch }, payload = null) {
    commit('changeKasKeluar', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/kas-keluar/${payload.id}`);
    commit('changeKasKeluar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('changeKasKeluar', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/kas-keluar/${payload.id}`);
    commit('changeKasKeluar', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKasKeluar', {
        detail: result.data.object,
      });
    }

    return !result.error ? true : false;
  },
};
